// src/pages/privates/Tools/index.tsx
import React from 'react';

import { IoArrowForward } from 'react-icons/io5';
import { RiWechatPayFill, RiMailSendFill } from 'react-icons/ri';
import { useHistory } from 'react-router-dom';

import {
  HeaderNavigationPrivate,
  MenuSideBarPrivate,
  SubtitleSecondary,
  CardHorizontalButtonNavigate,
} from '@components/index';
import { ConfigStyles, ConfigRoutes } from '@config/index';

import { Container, ContainerGroup, Content, CardItems } from './styles';

const ExternalServices: React.FC = () => {
  const { push } = useHistory();
  return (
    <Container>
      <HeaderNavigationPrivate />
      <ContainerGroup>
        <MenuSideBarPrivate />
        <Content>
          <SubtitleSecondary textAlign="start">
            Serviços Externos
          </SubtitleSecondary>
          <CardItems>
            <CardHorizontalButtonNavigate
              style={{
                padding: '3vh 1vw',
              }}
              icon={{
                element: RiWechatPayFill,
                size: 20,
                opacity: 1,
                colorDefault: ConfigStyles.rebox.colors.black.opacity.average,
                colorHover: ConfigStyles.rebox.colors.white.main,
              }}
              label={{
                text: 'Hand-Chat',
                colorDefault: ConfigStyles.rebox.colors.black.opacity.average,
                colorHover: ConfigStyles.rebox.colors.blue.main,
              }}
              message={{
                text: 'Serviços do hand-chat',
                colorDefault: ConfigStyles.rebox.colors.black.opacity.average,
                colorHover: ConfigStyles.rebox.colors.blue.main,
              }}
              marginBottom="2vh"
              positionContent="center"
              options={
                <IoArrowForward
                  size={16}
                  color={ConfigStyles.rebox.colors.black.main}
                  opacity={1}
                />
              }
              onClick={async () => {
                push(
                  ConfigRoutes.rebox.privates.externalServices.next.handChat
                    .path,
                );
              }}
            />
            <CardHorizontalButtonNavigate
              style={{
                padding: '3vh 1vw',
              }}
              icon={{
                element: RiMailSendFill,
                size: 20,
                opacity: 1,
                colorDefault: ConfigStyles.rebox.colors.black.opacity.average,
                colorHover: ConfigStyles.rebox.colors.white.main,
              }}
              label={{
                text: 'Disparo Manual Autentique',
                colorDefault: ConfigStyles.rebox.colors.black.opacity.average,
                colorHover: ConfigStyles.rebox.colors.blue.main,
              }}
              message={{
                text: 'Serviço de contrato de comodato',
                colorDefault: ConfigStyles.rebox.colors.black.opacity.average,
                colorHover: ConfigStyles.rebox.colors.blue.main,
              }}
              marginBottom="2vh"
              positionContent="center"
              options={
                <IoArrowForward
                  size={16}
                  color={ConfigStyles.rebox.colors.black.main}
                  opacity={1}
                />
              }
              onClick={async () => {
                push(
                  ConfigRoutes.rebox.privates.externalServices.next
                    .triggerAutentique.path,
                );
              }}
            />
          </CardItems>
        </Content>
      </ContainerGroup>
    </Container>
  );
};

export default ExternalServices;
